import { OnboardedUsers } from 'src/types/localStorage';

export const addOnboardedUser = (id: string, onboardedUsers: OnboardedUsers): OnboardedUsers => {
  return [...onboardedUsers, id];
};

export const hasOnboardedUser = (id: string, onboardedUsers: OnboardedUsers): boolean => {
  return !onboardedUsers.includes(id);
};
